import axios from 'axios';
import React, { useRef } from 'react';
import { ACData } from '../interfaces';
import BuildCard from '../partials/build_card';
import { Button, Classes, H5, Intent, OverlayToaster, Popover } from '@blueprintjs/core';
import { LoaderFunctionArgs, useLoaderData, useNavigate } from 'react-router-dom';


export async function loader({ request, params }: LoaderFunctionArgs) {
  let url: URL;

  if (Object.keys(params).length === 0) {
    url = new URL(`${process.env.REACT_APP_API_BASE_URL}/api/build`);
  } else {
    url = new URL(`${process.env.REACT_APP_API_BASE_URL}/api/user/${params.id}/build`);
  }

  try {
    const response = await axios.get(url.toString());
    return response.data['items'];
  } catch (error) {
    console.log(error);
    return [];
  }
}

interface BuildsProps {
  showDelete?: boolean
}
export default function Builds({ showDelete }: BuildsProps) {
  const builds = useLoaderData() as ACData[];
  const navigate = useNavigate();
  const toasterRef = useRef<OverlayToaster>(null);


  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
        {builds.map((e, i) => {
          return (
            <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "25px" }}>
              <BuildCard acData={e} onClick={() => { window.open(`${process.env.REACT_APP_API_BASE_URL}/garage/${e['id']}`, "_self") }} interactive />
              {showDelete &&
                <Popover
                  content={<div style={{ padding: "10px" }}>
                    <H5>Confirm Delete</H5>
                    <p>Are you sure you want to delete this build?</p>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button className={Classes.POPOVER_DISMISS} text="Cancel" />
                      <Button
                        className={Classes.POPOVER_DISMISS}
                        intent={Intent.DANGER}
                        text="Confirm"
                        onClick={() => {
                          axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/build/${e['id']}`)
                            .then(response => {
                              if (response.status === 200) {
                                toasterRef.current?.show({
                                  intent: Intent.SUCCESS,
                                  icon: "tick",
                                  message: `Deleted Build`,
                                });
                                navigate('.', { replace: true })
                              }
                            })
                            .catch(error => {
                              const status = error.response.status;

                              toasterRef.current?.show({
                                intent: Intent.DANGER,
                                icon: "warning-sign",
                                message: `Error ${status}: ${status === 500 ? "Internal Server Error" : JSON.stringify(error.response.data)}`,
                              })
                            })
                        }} />
                    </div>
                  </div>}>
                  <Button text="Delete" minimal />
                </Popover>
              }
            </div>
          );
        })}
      </div>
      <OverlayToaster ref={toasterRef} />
    </div>
  );
}